import { render, staticRenderFns } from "./UploadArchive.vue?vue&type=template&id=1bc54cf1&scoped=true&"
import script from "./UploadArchive.vue?vue&type=script&lang=js&"
export * from "./UploadArchive.vue?vue&type=script&lang=js&"
import style0 from "./UploadArchive.vue?vue&type=style&index=0&id=1bc54cf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc54cf1",
  null
  
)

export default component.exports